import { trackEvent } from './analytics';

type ContactClickChannel = 'phone' | 'whatsapp' | 'email' | 'devis';

const CONTACT_SELECTOR = '[data-track="devis"], a[href^="tel:"], a[href*="wa.me/"], a[href^="mailto:"]';

const SECTION_ID_MAP: Record<string, string> = { home: 'hero' };

let isInitialized = false;

function getChannel(el: Element): ContactClickChannel {
  if (el.matches('[data-track="devis"]')) return 'devis';
  const href = el.getAttribute('href') ?? '';
  if (href.startsWith('tel:')) return 'phone';
  if (href.includes('wa.me/')) return 'whatsapp';
  return 'email';
}

function getSection(el: Element): string {
  const cta = el.closest<HTMLElement>('[data-cta-location]')?.dataset.ctaLocation;
  if (cta) return cta;
  const section = el.closest<HTMLElement>('[data-section]')?.dataset.section;
  if (section) return section;
  const id = el.closest('section[id]')?.id;
  if (id) return SECTION_ID_MAP[id] ?? id;
  if (el.closest('header, nav')) return 'header';
  if (el.closest('footer')) return 'footer';
  return 'contenu';
}

function handleClick(event: MouseEvent): void {
  if (!(event.target instanceof Element)) return;
  const el = event.target.closest(CONTACT_SELECTOR);
  if (!el) return;
  trackEvent('contact_click', {
    channel: getChannel(el),
    section: getSection(el),
    link_url: el.getAttribute('href') ?? '',
    page_path: window.location.pathname,
  });
}

/** Évènement générique contact_click (tel, WhatsApp, e-mail, devis). Idempotent. */
export function initContactClickTracking(): void {
  if (isInitialized || typeof document === 'undefined') return;
  isInitialized = true;
  document.addEventListener('click', handleClick, { capture: true });
}
